import { Button, Card, Descriptions, Empty, Spin, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { usePpeNorm } from '@/entities/ppe/api/hooks';
import s from './PpeNormDetail.module.scss';

const { Paragraph, Text, Title } = Typography;

export function PpeNormDetail() {
  const { normId } = useParams<{ normId: string }>();
  const id = Number(normId);
  const navigate = useNavigate();
  const { data, isLoading } = usePpeNorm(id);

  if (!Number.isFinite(id) || id <= 0) {
    return <Empty description="Некорректный идентификатор нормы" />;
  }

  return (
    <>
      <Button type="link" className={s.root__back} onClick={() => navigate('/siz')}>
        ← К нормам СИЗ
      </Button>

      <Spin spinning={isLoading}>
        {!isLoading && data === null ? (
          <Empty description="Норма не найдена" />
        ) : data ? (
          <Card className={s['root__header-card']} classNames={{ body: s['root__header-body'] }}>
            <div className={s['root__header-top']}>
              <div>
                <Title level={5} className={s['root__header-title']}>
                  Норма СИЗ — {data.ppeName}
                </Title>
                <Text type="secondary" className={s['root__header-sub']}>
                  {data.position}
                </Text>
              </div>
            </div>

            <Descriptions column={{ xs: 1, sm: 3 }} size="small" className={s['root__compact-desc']}>
              <Descriptions.Item label="Разряд ЕТКС">{data.etksRank ?? '—'}</Descriptions.Item>
              <Descriptions.Item label="Класс условий труда">{data.conditionClass ?? '—'}</Descriptions.Item>
              <Descriptions.Item label="Действует с">{data.effectiveFrom}</Descriptions.Item>
              <Descriptions.Item label="Норма выдачи">{data.quantity}</Descriptions.Item>
              <Descriptions.Item label="Периодичность">{data.period}</Descriptions.Item>
              <Descriptions.Item label="ГОСТ / ТУ">{data.gostTu ?? '—'}</Descriptions.Item>
            </Descriptions>

            <Paragraph className={s.root__block} strong>
              Уход и хранение
            </Paragraph>
            <Paragraph type="secondary">{data.careInstructions ?? '—'}</Paragraph>

            <Paragraph className={s.root__block} strong>
              Замена / аналоги
            </Paragraph>
            <Paragraph type="secondary">{data.substitutionRule ?? '—'}</Paragraph>
          </Card>
        ) : null}
      </Spin>
    </>
  );
}
